// The dialog's ImportFailureReporter, wired to the GraphQL client and a plain PUT.

import graphClient from '../../utils/graphql/graph_client';
import { GenerateImportFailureUpload, ReportImportFailure } from '../../utils/graphql/import-failure-graph';
import { ImportFailureReporter, sendImportFailureReport, type ImportFailureReportDeps } from '../../utils/import/importFailureReport';

const deps: ImportFailureReportDeps = {
  request: (document, variables) => graphClient.request(document as any, variables),
  put: async (url, headers, body) => {
    const response = await fetch(url, { method: 'PUT', headers, body: body as BodyInit });
    if (!response.ok) throw new Error(`Upload failed: ${response.status}`);
  },
  mutations: { generateDirectUpload: GenerateImportFailureUpload, reportImportFailure: ReportImportFailure }
};

export function failureReporter(
  fileOf: (source: string) => File | null,
  ask: (fileNames: string[]) => Promise<boolean>
): ImportFailureReporter {
  return new ImportFailureReporter(
    source => {
      const file = fileOf(source);
      return file ? { size: file.size, bytes: async () => new Uint8Array(await file.arrayBuffer()) } : null;
    },
    report => sendImportFailureReport(report, deps),
    ask
  );
}
